import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input } from '@angular/core';

import { IBlock, siteHtmlOf, titledOfContent } from '@rt-tools/cms-contract';
import { BlockDirective, ElemDirective } from '@rt-tools/core';

const BEM_BLOCK: string = 'sc-blog-quote-block';

@Component({
    selector: 'sc-blog-quote-block',
    templateUrl: './blog-quote-block.component.html',
    styleUrl: './blog-quote-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BlogQuoteBlockComponent {
    protected readonly quote: Signal<IBlock.Content.Note> = computed(() => {
        const titled: IBlock.Content.Note = titledOfContent(this.content());
        return { ...titled, text: siteHtmlOf(titled.text) };
    });

    /** Содержимое блока цитаты: автор и HTML текста. */
    public readonly content: InputSignal<string> = input.required<string>();
}
